import { render, staticRenderFns } from "./ModalPhieuSoKet.vue?vue&type=template&id=21d90407"
import script from "./ModalPhieuSoKet.vue?vue&type=script&lang=js"
export * from "./ModalPhieuSoKet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports